export const formatItemPacker = (packer: string) => {
  const splitPacker = packer && typeof packer === "string" ? packer.split(" ") : "";

  let packerFormatted = "";

  if (splitPacker) {
    if (splitPacker.length === 2) {
      packerFormatted = `${splitPacker[0].slice(0, 1)}${splitPacker[1].slice(0, 1)}`;
    } else {
      packerFormatted = `${splitPacker[0].slice(0, 1)}`;
    }
  }

  return packerFormatted;
};
